import { Component, HostListener } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { environment } from '../environments/environment';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css']
})
export class AppComponent {
    title = 'app';
    isPatentPlusUser: boolean = false;
    logoPath: string;
    isCustCorp: boolean;
    constructor(private _router: Router) {
        _router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                var currentUrl = event.url;
                if (currentUrl != null) {
                    var splitUrl = currentUrl.split('/', 3);
                    var contractSplitUrl = currentUrl.split('/', 6);
                }
                //this.isPatentPlusUser = ((contractSplitUrl.length > 3 && +contractSplitUrl[3].split('?')[0] == 1) || (contractSplitUrl.length > 6 && +contractSplitUrl[6].split('?')[0] == 1) || (splitUrl.length > 0 && (splitUrl[1].startsWith("patent")))) ? true : false;
                //this.logoPath = this.isPatentPlusUser ? "assets/images/logo/Patent-Plus.png" : "assets/images/logo/logo_1226.png";
                this.logoPath = "assets/images/logo/logo_1226.png";
                this.isCustCorp = (splitUrl.length > 0 && (splitUrl[1].includes("cust-contract") || splitUrl[1].includes("corp-contract") || splitUrl[1].includes("thankyou") || splitUrl[1].includes("document-export") || splitUrl[1].includes("contractlistener"))) ? true : false;
            };
        });
    }

    ngOnInit(): void { }
}
